module.exports = __webpack_public_path__ + "static/media/Manto.31880cfc.jpg";